import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import DashboardHeader from '../components/DashboardHeader';

function DashboardLayout() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    // This div is now 'flex' (row-based)
    <div className="relative flex h-auto min-h-screen w-full"> 
      
      <Sidebar 
        isSidebarOpen={isSidebarOpen} 
        setIsSidebarOpen={setIsSidebarOpen} 
      />
      
      {/* On mobile, sidebar is 'fixed' (out of flow), main takes 100% width.
        On desktop, sidebar is 'sticky' (in flow), main uses 'flex-1' to fill the rest.
        No margin-left is needed.
      */}
      <main className="flex flex-1 flex-col">
        <DashboardHeader setIsSidebarOpen={setIsSidebarOpen} />
        <Outlet />
      </main>
    </div>
  );
}

export default DashboardLayout;
